import classNames from 'classnames'
import { type ButtonHTMLAttributes, type ReactNode } from 'react'

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    icon?: ReactNode
    iconPosition?: 'start' | 'end'
    mode?: 'icon' | 'label'
    rounded?: 'soft' | 'full' | 'left' | 'right'
}

const roundedClassNames: Record<NonNullable<ButtonProps['rounded']>, string> = {
    soft: 'rounded-[20px]',
    full: 'rounded-full',
    left: 'rounded-l-full rounded-r-[20px]',
    right: 'rounded-l-[20px] rounded-r-full',
}

export const Button = ({
    children,
    className,
    disabled,
    icon,
    iconPosition = 'end',
    mode = 'icon',
    rounded = 'soft',
    type = 'button',
    ...props
}: ButtonProps) => {
    const hasLabel = children !== undefined && children !== null

    return (
        <button
            type={type}
            disabled={disabled}
            className={classNames(
                'group relative inline-flex items-center justify-center gap-1.5 border-0 font-medium shadow-[inset_0_0.5px_0_1px_rgba(255,255,255,0.23),inset_0_1px_0_0_rgba(255,255,255,0.66),0_4px_16px_rgba(0,0,0,0.12)] outline-none backdrop-blur-[30px] transition-all duration-200 disabled:cursor-default disabled:opacity-45',
                roundedClassNames[rounded],
                {
                    'h-9 w-9 bg-transparent p-0 text-white': mode === 'icon',
                    'rounded-xl bg-white/10 px-6 py-3 text-black': mode === 'label',
                },
                className
            )}
            {...props}
        >
            <span
                className={classNames(
                    'absolute inset-0 overflow-hidden transition-opacity duration-300 group-hover:opacity-30',
                    roundedClassNames[rounded]
                )}
            >
                <span className="absolute inset-0 bg-[linear-gradient(180deg,rgba(255,255,255,0.28)_0%,rgba(255,255,255,0)_100%)]" />
            </span>
            {iconPosition === 'start' && icon ? <span className="relative z-[1] shrink-0">{icon}</span> : null}
            {hasLabel ? <span className="relative z-[1]">{children}</span> : null}
            {iconPosition === 'end' && icon ? <span className="relative z-[1] shrink-0">{icon}</span> : null}
        </button>
    )
}
